import { useMutation } from '@apollo/client'
import { Event, AddEventVariables } from '../../types'
import { ADD_EVENT } from './operations'


export const useAddEvent = () =>
  useMutation<Event, AddEventVariables>(ADD_EVENT)